import { API } from './resources'

export default {
  getProjectPosts: (id, limit, offset, sort, before, since) => {
    return API.get(`projects/${id}/posts`, { params: { limit, offset, sort, before, since } })
  },
  getProjectPostsAndComments: (id, limit, sort, since) => {
    return API.get(`projects/${id}/postsandcomments`, { params: { limit, sort, since } })
  },
  loadToPost: (id, postID, sort, limit) => {
    return API.get(`projects/${id}/posts/${postID}`, { params: { sort, limit } })
  },
  loadToPostsAndComments: (id, postID, sort) => {
    return API.get(`projects/${id}/postsandcomments/${postID}`, { params: { sort } })
  },
  create: (data) => {
    return API.post('/posts', data)
  },
  get: (id) => {
    return API.get(`/posts/${id}`)
  },
  getAll: (id) => {
    return API.get('/posts')
  },
  getAllForUser: (limit, offset, sort, before, since) => {
    return API.get('/posts/user', { params: { limit, offset, sort, before, since } })
  },
  update: (id, data) => {
    return API.put(`/posts/${id}`, data)
  },
  updatePriority: (id, data) => {
    return API.put(`/posts/${id}/priority`, data)
  },
  delete: (id) => {
    return API.delete(`/posts/${id}`)
  },
  addAttachment: (id, data) => {
    return API.post(`/posts/${id}/attachments`, data)
  },
  getAttachments: (id) => {
    return API.get(`/posts/${id}/attachments/`)
  },
  updateAttachment: (id, attachmentID, data) => {
    return API.put(`/posts/${id}/attachments/${attachmentID}`, data)
  },
  deleteAttachment: (id, attachmentID) => {
    return API.delete(`/posts/${id}/attachments/${attachmentID}`)
  },
  getAttachment: (id, attachmentID) => {
    return API.get(`/posts/${id}/attachments/${attachmentID}`)
  },
  copyAttachment: (id, attachmentID) => {
    return API.post(`/posts/${id}/attachments/${attachmentID}/copy`)
  },
  getLikes: (id, limit, offset) => {
    return API.get(`/posts/${id}/likes`, { params: { limit, offset } })
  },
  hasLiked: (id, username) => {
    return API.get(`/posts/${id}/like/${username}`)
  },
  like: (id) => {
    return API.post(`/posts/${id}/like`)
  },
  unlike: (id) => {
    return API.delete(`/posts/${id}/like`)
  },
  getComments: (id, limit, offset, before, since) => {
    return API.get(`/posts/${id}/comments`, { params: { limit, offset, before, since } })
  },
  getReplies: (id, commentID, limit, offset, before, since) => {
    return API.get(`/posts/${id}/comments/${commentID}/replies`, { params: { limit, offset, before, since } })
  },
  createComment: (id, body, anonymous, attachments) => {
    return API.post(`/posts/${id}/comments`, { body, anonymous, attachments })
  },
  createReply: (id, body, anonymous, attachments, parentID) => {
    return API.post(`/posts/${id}/comments/${parentID}/replies`, { body, anonymous, attachments })
  },
  searchImages: (query, limit, page) => {
    return API.get('/posts/images', { params: { query, limit, page } })
  },
  updateSettings: (id, data) => {
    return API.post(`/posts/${id}/updatesettings`, data)
  },
  updatePostStatus: (postID, projectID, status) => {
    return API.put(`/posts/updateStatus/${projectID}`, { postID, status })
  }
}
